import React, { useCallback, useState } from 'react';

import { TGetEventsEventDetails } from '../../types';
import { RsvpModal } from '../rsvp-modal/rsvp-modal';
import { EventDetails } from './event-details';

export interface IEventDetailsContainerProps {
  event: NonNullable<TGetEventsEventDetails>;
}

const openNewWindow = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const EventDetailsContainer: React.FC<
  React.PropsWithChildren<IEventDetailsContainerProps>
> = ({ event }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeRsvpModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const openRsvpModalForEvent = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <>
      <EventDetails
        event={event}
        onModalOpen={openRsvpModalForEvent}
        onWindowOpen={openNewWindow}
      />
      <RsvpModal
        event={event}
        isModalOpen={isModalOpen}
        onCloseModal={closeRsvpModal}
      />
    </>
  );
};
